import {
    AISMLLMAPI,
    BPIAM_API,
    KNOWLEDGE,
    KNOWLEDGE_API,
    MARKETING_API,
    OSS_API,
  } from '@/constants/API';
  import { request } from '@umijs/max';
  
  
  // 获取 热点
  export async function getHotspotList({
    keyword,
    id,
    page,
    pageSize,
  }: any) {
    return request(`${MARKETING_API}/assistant/hotspot/list/${id}/${page}/${pageSize}`, {
      method: 'POST',
      data: {
        keyword,
      },
    });
  }

  // 获取 智推热点
  export async function getHotspotDashboard({
    keyword,
    id,
  }: any) {
    return request(`${MARKETING_API}/assistant/hotspot/dashboard/${id}`, {
      method: 'POST',
      data: {
        keyword,
      },
    });
  }
  
  // 生成方案 日历
  export async function dataBuildAScenario(params: any) {
    return request(`${MARKETING_API}/scheme/parameter/dataBuildAScenario`, {
      method: 'POST',
      data: {
        ...params,
        appId: process.env.appId,
      },
    });
  }

    // 智推详情
    export async function getSmartPushSchemeDetails(analysisId: any) {
      return request(`${MARKETING_API}/scheme/parameter/getSmartPushSchemeDetails/${analysisId}`, {
 
      });
    }